// extracted by mini-css-extract-plugin
export default {"overview-card":"y8l3x","shake":"YlsjJ","stats-section":"kH66v","action-section":"l35Lo","empty-state":"ogtPo"};